var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParticipante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20642 0.83125C3.66873 0.83125 4.04337 1.2425 4.04337 1.75C4.04337 2.2575 3.66873 2.66875 3.20642 2.66875C2.74411 2.66875 2.36948 2.2575 2.36948 1.75C2.36948 1.2425 2.74411 0.83125 3.20642 0.83125ZM3.20642 4.76875C4.3901 4.76875 5.63754 5.4075 5.63754 5.6875V6.16875H0.775301V5.6875C0.775301 5.4075 2.02275 4.76875 3.20642 4.76875ZM3.20642 0C2.32564 0 1.61224 0.783125 1.61224 1.75C1.61224 2.71688 2.32564 3.5 3.20642 3.5C4.08721 3.5 4.8006 2.71688 4.8006 1.75C4.8006 0.783125 4.08721 0 3.20642 0ZM3.20642 3.9375C2.14231 3.9375 0.0180664 4.52375 0.0180664 5.6875V6.5625C0.0180664 6.80312 0.197411 7 0.416611 7H5.99623C6.21543 7 6.39478 6.80312 6.39478 6.5625V5.6875C6.39478 4.52375 4.27054 3.9375 3.20642 3.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipante);
export default __webpack_public_path__ + "static/media/participante.3ba6dd6193ff02e297810575bd7f9d6f.svg";
export { ForwardRef as ReactComponent };